module.exports = __webpack_public_path__ + "static/media/status-pending-white.a30acad2.svg";